// src/lib/skuValidation.ts

import type { MaterialLineItem } from "@/data/types";
import type { RegistryProduct } from "@/data/ProductRegistryContext";

/** Normalise a raw SKU value to a consistent uppercase trimmed string. */
export function normalizeSku(value: unknown): string {
  return String(value ?? "").trim().toUpperCase();
}

/**
 * Returns the list of SKU strings from `materialsList` that have no matching
 * entry in `registryProducts`. An empty array means all SKUs are matched.
 */
export function getUnmatchedSkus(
  materialsList: MaterialLineItem[] | undefined,
  registryProducts: RegistryProduct[],
): string[] {
  if (!materialsList || materialsList.length === 0) return [];
  const registrySet = new Set(
    registryProducts.map((p) => normalizeSku(p.sku)).filter(Boolean),
  );
  return materialsList
    .filter((m) => {
      const sku = normalizeSku(m.sku);
      return sku !== "" && !registrySet.has(sku);
    })
    .map((m) => normalizeSku(m.sku));
}
